import { userClient } from './auth'

/** 내 쿠폰 가져오기 */
export async function getUsableCoupon() {
  return await userClient.get(`/coupons?usable=true`)
}

export async function getUsableCountCoupon(pageSize: number) {
  return await userClient.get(`/coupons?usable=true&pageSize=${pageSize}`)
}

export async function getUnUsableCoupon() {
  return await userClient.get(`/coupons?usable=false`)
}

export async function getUnUsableCountCoupon(pageSize: number) {
  return await userClient.get(`/coupons?usable=false&pageSize=${pageSize}`)
}

/** 상품 번호로 쿠폰 발급하기 */
export async function postCouponDownload(productNo: string) {
  return await userClient.post(`/coupons/products/${productNo}/download`, {})
}

/** 적용할 수 있는 쿠폰 정보 조회하기 */
export async function getSubmitCoupons(orderSheetNo: string | number) {
  return await userClient.get(`/order-sheets/${orderSheetNo}/coupons`)
}

/** 쿠폰 적용하기 */
export async function postApplyCoupons(orderSheetNo: string | number, item: any) {
  return await userClient.post(`/order-sheets/${orderSheetNo}/coupons/apply`, item)
}

/** 쿠폰적용금액 계산하기 */
export async function postCalculateCoupons(orderSheetNo: string, item: any) {
  return await userClient.post(`/order-sheets/${orderSheetNo}/coupons/calculate`, item)
}

/** 상품 번호로 발급 가능한 쿠폰 조회 */
export async function getIssuableCoupon(productNo: any) {
  return await userClient.get(`/coupons/products/${productNo}/issuable/coupons`)
}

/** 쿠폰번호로 쿠폰 발급하기 */
export async function postCouponNoDownload(couponNo: number) {
  return await userClient.post(`/coupons/${couponNo}/download`)
}

/** 상품번호로 쿠폰 발급하기 */
export async function postProductNoDownload(productNo: string) {
  return await userClient.post(`/coupons/products/${productNo}/download`)
}

/** 발급 가능한 쿠폰 조회 */
export async function getIssuableAllCoupon() {
  return await userClient.get(`/coupons/issuable`)
}

/** 쿠폰번호로 대상 조회 */
export async function getTarget(couponNo: number) {
  return await userClient.get(`/coupons/${couponNo}/targets`)
}

/** 코드 쿠폰 발급하기 */
export async function postPromotion(promotionCode: string) {
  return await userClient.post(`/coupons/register-code/${promotionCode}`)
}
